//
//
//
//
//

const COMPONENT_NAME = 'loading'
export default {
  name: COMPONENT_NAME
}



// WEBPACK FOOTER //
// ./src/components/base/loading/loading.vue